import { SchedulingFrequency } from '../../../types';
export function frequencyToString(freq) {
    return freq === null || freq === void 0 ? void 0 : freq.toString();
}
export default function dtoToScheduling(values, localeWeekdays) {
    var _a;
    switch (values.schedulePeriod) {
        case SchedulingFrequency.Hours:
            return {
                frequency: SchedulingFrequency.Hours,
                interval: frequencyToString(values.scheduleFrequency),
            };
        case SchedulingFrequency.Days:
            return {
                frequency: SchedulingFrequency.Days,
                interval: frequencyToString(values.scheduleFrequency),
                time: values.scheduleTime,
            };
        case SchedulingFrequency.Weeks:
            return {
                frequency: SchedulingFrequency.Weeks,
                interval: frequencyToString(values.scheduleFrequency),
                time: values.scheduleTime,
                weekdays: (_a = values.weekDays) === null || _a === void 0 ? void 0 : _a.map(function (day) {
                    var _a, _b;
                    return ({
                        label: (_b = (_a = localeWeekdays.find(function (weekday) { return weekday.weekday === day; })) === null || _a === void 0 ? void 0 : _a.long) !== null && _b !== void 0 ? _b : day, // should not happen
                        value: day,
                    });
                }),
            };
        case SchedulingFrequency.Manual:
        default:
            return { frequency: SchedulingFrequency.Manual };
    }
}
